/* eslint-disable camelcase */
import type {
  RegistrationResultDto,
  RegistrationResultModel,
} from '@hotjar/webapp/domains/acquisition/register/dto';

import type { InvitationResponse, InvitationModelResponse, AcceptInviteRequestDto } from './dto';
import type { AcceptInvite } from './model';

export const invitationDtoToModel = ({
  success,
  invitation,
}: InvitationResponse): InvitationModelResponse => ({
  success,
  invitation: invitation
    ? {
        email: invitation.email,
        identityProvider: invitation.identity_provider
          ? {
              displayName: invitation.identity_provider.display_name,
              id: invitation.identity_provider.id,
            }
          : undefined,
        organizationName: invitation.organization_name,
      }
    : undefined,
});

export const acceptInviteModelToDto = ({
  name,
  email,
  terms,
  password,
  recaptcha,
  ssoProvider,
  token,
  role,
  ssoToken,
  subscribeToEmails,
  locale,
}: AcceptInvite): AcceptInviteRequestDto => ({
  name,
  email,
  terms,
  password,
  recaptcha,
  sso_provider: ssoProvider,
  sso_token: ssoToken,
  token,
  role,
  locale,
  subscribe_to_emails: subscribeToEmails,
});

export const acceptInviteDtoToModel = ({
  accessKey,
  enforced_mfa,
  success,
  user_id,
}: RegistrationResultDto): RegistrationResultModel => ({
  accessKey,
  enforcedMfa: enforced_mfa,
  success,
  userId: user_id,
});
